module.exports = __webpack_public_path__ + "media/packs/assets/images/arrow-down-c0cea0a5f6693f8cbcbe4fa40597198a.png";